<template>
<div class="viewport">
  <template>
    <div class="card"  v-for="item in productData" :key="item.id">
      <div class="goods">
        <van-image class="thumb"
                   :src="item.productPic"></van-image>
        <div class="name ellipsis">{{item.productName}}</div>
        <div class="extra">{{item.productSpec}}</div>
      </div>
      <van-field label="商品评分">
        <template #input>
          <van-radio-group v-model="item.kind" direction="horizontal">
            <van-radio name="3" checked-color="#fa436a">差评</van-radio>
            <van-radio name="2" checked-color="#fa436a">中评</van-radio>
            <van-radio name="1" checked-color="#fa436a">好评</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
          v-model="item.context"
          label="评价下单"
          type="textarea"
          placeholder="请输入...."
          row="2"
          :border="false"
      />
      <van-field label="上传图片" :border="false">
        <template #input>
          <van-uploader
              v-model="item.url"
              multiple
              :after-read="(file)=>afterRead(file,item.id)"
              :before-read="beforeRead"
          />
        </template>
      </van-field>

    </div>
    <div style="margin: 16px;"  v-if="commentStatus !== 1">
      <van-button round block type="info" @click="submit">提交</van-button>
    </div>
  </template>
</div>
</template>

<script>
export default {
  name: "appraise",
  data(){
    return {
      orderId:null,
      productData:[],
      success:false,
      commentStatus:''
    }
  },
  mounted() {
    let query = this.$route.query
    this.orderId = query.orderId * 1
    this.loadData()
  },
  methods:{
    loadData() {
      this.getOrder()
    },
    getOrder () {
      this.$http.request(this.$http.pathMap.orderInfo + '/' + this.orderId,
          'get').then(res => {
        var resultData = res.data.order.orderItems
        this.commentStatus = res.data.order.commentStatus
        resultData.forEach(item =>{
          item.context = ""
          item.kind = ""
          item.url = []
        })
        this.productData = resultData
        if(res.data.order.commentStatus == 1) {
          this.detail()
        }
       })
    },
    detail() {
      this.$http.request(this.$http.pathMap.appraiseDetail,'post',{orderId:this.orderId}).then(res => {
        this.productData.forEach(item => {
          res.data.forEach(d => {
            item.context = d.context
            item.kind = d.kind.toString()
            item.url = d.url.split(',')
          })
        })
        // console.log(this.productData,2)
      })
    },
    beforeRead(file) {
      const fileSize = file.size/1024/1024 < 1
      if(!fileSize) {
        this.$toast('上传文件不能大于1M')
        return false
      }
      return true
    },
    afterRead(file,id) {

      let f = file.file

      if (file) {
        this.$http.upload(f).then(res => {
          let data = res.data
          let copyUrl = []
          copyUrl.push(data)
          this.productData.forEach(item => {
            // console.log(item.url)
            if(id == item.id) {
              item.copyUrl = copyUrl
            }

          })
        })
      }
    },
    submit() {
      let data = []
      this.productData.forEach(item => {
        data.push({
          context:item.context,
          kind:item.kind,
          url:item.copyUrl.join(','),
          productId:item. productId,
          orderId:this.orderId,
          productStockId:item.productStockId

        })
      })
      this.$http.request(this.$http.pathMap.appraiseComment,'post',data).then(res => {
        this.$router.back()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.viewport {
  padding: 0 10px 10px;
  .card {
    padding: 15px 10px 10px;
    margin-top: 10px;

    .goods {
      height: 70px;
      margin-bottom: 10px;
      .thumb {
        width: 70px;
        height: 70px;
        margin-right: 10px;
        float: left;
      }
      .name {
        height: 45px;
        font-size: 14px;
        color: #333;
      }
      .extra {
        line-height: 1;
        margin-top: 9px;
        font-size: 13px;
        color: #999;
      }
    }
  }
}
.level {
  font-size: 14px;
  color: #333;
  margin-left: 10px;

}
</style>
